<template>
  <v-card
    @click="() => typeof widget.link!=='undefined' ? move(widget.link) : null"
    v-if="widget.template==='defaultTableDesign'"
    :style="widget.color==='primary' ? 'background-color: #0575e6; background-image: linear-gradient(to right, #0575e6, #021b79)' : widget.color==='warning' ? 'background-color: #fdc830; background-image: linear-gradient(to right, #fdc830, #f37335)' : widget.color==='success' ? 'background: linear-gradient(to right, #34e89e, #0f3443)' : widget.color==='error' ? 'background-color: #eb5757; background-image: linear-gradient(to right, #eb5757, #000000)' : 'background:' + widget.color "
    dark
    class="ma-0"
  >
    <v-card-title class="text-h5">
      {{ widget.title }}
    </v-card-title>
    <v-card-actions>
      <v-btn text>
        {{ isNaN(widget.model) ? widget.model : Intl.NumberFormat().format(parseInt(widget.model)) }} {{ widget.prefix }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import router from "@/router";

export default {
  name: "tile-default-table-design",
  props: {
    widget: Object
  },
  methods: {
    move(link) {
      let result = link.includes("http");
      if (result) {
        window.location.href = link
      } else {
        router.push(link)
      }
    }
  }
}
</script>

<style scoped>

</style>
